import React from 'react';
import IForm from '../../../../types/IForm';
import { RefreshCallback } from '../../../FetchContainer';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { AcceptDeclineForm } from '../../../Form2/standardForms/AcceptDeclineForm/AcceptDeclineForm';

export function UserMembershipDeleteForm({ form, onSuccess }: { form: IForm; onSuccess: RefreshCallback }) {
  const { t } = useSonTranslation('UserMemberships');

  return (
    <AcceptDeclineForm
      form={form as any}
      headline={t('delete.question')}
      onSuccess={onSuccess}
      messageSuccess={t('delete.status.success')}
      messageSending={t('delete.status.sending')}
      messageFail={t('delete.status.fail')}
    />
  );
}
